import React from 'react';
var HeaderDropdownSeparator = function () { return (React.createElement("li", null,
    React.createElement("hr", { role: "separator", "aria-orientation": "horizontal", className: "o-header-dropdown-divider" }))); };
export default React.memo(HeaderDropdownSeparator);
